<template>
  <div class="container">
    <div class="column">
      <div class="footer-logo">学术视野出版社</div>
      <div class="footer-logo-eng">SCHOLAR HORIZONS PRESS PTE. LTD.</div>
    </div>
    <div class="column footer-links">
      <p class="links" @click="fun('/chineseItem?type=1')">
        {{ $t("navbar.Academic") }}
      </p>
      <p class="links" @click="fun('/chineseItem?type=2')">
        {{ $t("navbar.Literary") }}
      </p>
      <p class="links" @click="fun('/chineseItem?type=3')">
        {{ $t("navbar.Translated") }}
      </p>
    </div>
    <div class="column footer-links">
      <p class="links" @click="fun('/aboutus')">
        {{ $t("navbar.ABOUT") }}
      </p>
      <p class="links" @click="fun('/contactItem')">
        {{ $t("navbar.CONTACT") }}
      </p>
    </div>
    <div class="column footer-contact">
      <p class="links">{{ $t("navbar.Email") }}: scholarhorizons@hotmail.com</p>
      <p class="links">{{ $t("navbar.Telephone") }}: +6580301448</p>
      <p class="links">
        {{ $t("navbar.Location") }} : Singapore Office 21 WOODLANDS CLOSE #02-10
        PRIMZ BIZHUB
      </p>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    fun(val) {
      document.documentElement.scrollTop = 0;
      this.$router.push(val);
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: space-around;
  padding: 10px 0;
  border: 1px solid #ccc;
}

.column {
  text-align: left;
}

.footer-logo {
  font-size: 0.4rem;
  font-weight: bold;
}
.footer-logo-eng {
  margin-top: 0.15rem;
  font-size: 0.3rem;
}

.footer-contact {
  width: 6rem;
}

.links {
  font-size: 0.25rem;
  margin-bottom: 0.15rem;
}
.footer-logo-eng {
  margin-top: 0.15rem;
  font-size: 0.3rem;
}

@media screen and (max-width: 854px) {
  .cright {
    padding-bottom: 10px;

    .in {
      line-height: 0.8rem;
    }

    .tit img {
      top: 1px;
    }
  }

  .cleft {
    display: none;
  }

  .copy {
    float: left;
    display: block;
    font-weight: bold;
  }
}

.clear {
  font: 0px Arial;
  line-height: 0;
  height: 0;
  overflow: hidden;
  clear: both;
}
</style>



// WEBPACK FOOTER //
// src/components/home/FootItem.vue